export const ASSET_CODE_FORMAT_RULE = {
  RULE_1: 1,
  RULE_2: 2,
  RULE_3: 3,
  RULE_4: 4,
}

export const LIST_ASSET_CODE_FORMAT = {
  2: {
    1: { format: 'YYYYMMDD' },
    2: { format: 'YYYYMM' },
    3: { format: 'YYYY' },
  },
  3: {
    1: { value: '-' },
    2: { value: '_' },
    3: { value: '.' },
  },
} as any
